import { MutableRefObject, useEffect, useRef } from 'react';

type VoidFunc = () => void;

// Basic polling implementation
// See https://bitbucket.org/mavenmachines/workspace/snippets/9X56aE
export function useInterval(callback: VoidFunc, delay: number): void {
  const savedCallback = useRef<VoidFunc | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function tick() {
      (savedCallback as MutableRefObject<VoidFunc>).current();
    }

    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}
